import React from "react";
import { useListing } from "@/providers";

export const FeatureDetails = () => {
    const { listingDetails } = useListing();

    const {
        features
    } = listingDetails;


    return (

        <div className="block !bg-transparent">
            <div className="block-section">
                <div className="block-body !px-0 flex flex-col">
                    <div className="mb-6 block-left">
                        <h3 className="pb-6 text-lg font-bold text-start">Features</h3>
                    </div>
                    {/* block-left */}
                    <div >
                        {features?.map((feature) => (
                            <div key={feature.id} className="mb-8">
                                <p className="font-bold text-gray-800">{feature.name}</p>
                                <ul className="grid grid-cols-2 gap-4 mt-2 detail-list">
                                    {feature.sub_features?.map((subFeature) => (
                                        <li
                                            key={subFeature.id}
                                            className="flex items-center space-x-2 text-gray-700 !m-0 !p-0"
                                        >
                                            <i className="text-green-500 fas fa-check-circle"></i>
                                            <span>{subFeature.sub_heading}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    {/* block-right */}
                </div>
                {/* block-body */}
            </div>
            {/* block-section */}
        </div>
    );
};
